export default function CsharpAssignmentOperators() {
  return (
    <h2>Csharp Assignment Operators</h2>
  );
}
